var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{staticClass:"tableborder",attrs:{"columns":_vm.columns,"data-source":_vm.data}},[_c('template',{slot:"operation"},[_c('span',{staticClass:"csP",staticStyle:{"color":"#7ebae5"}},[_vm._v("回复")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }